var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 237,
    viewBox: "0 0 416 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.956 28.3573L165.089 1.59814L144.452 78.6157L244.32 105.375L264.956 28.3573Z",
    fill: "#F2F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.062 230.684C122.062 230.684 121.802 230.288 121.531 229.874C121.163 229.31 121.161 228.583 121.526 228.018C121.596 227.909 121.666 227.801 121.732 227.699C121.979 227.316 122.37 227.048 122.816 226.955C130.29 225.399 136.294 223.098 141.215 220.248C143.043 213.897 144.758 213.85 147.297 214.275",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.652 215.595C148.333 224.343 157.403 221.953 160.9 215.166C165.566 215.735 167.332 222.036 167.961 230.586L122.062 230.684",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.758 228.378L167.737 228.111",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 215.166L162.028 208.222",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.572 215.168L148.468 208.022",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.354 132.238C261.354 132.238 257.635 133.175 254.555 132.238L233.94 146.566L234.971 121.624C232.117 129.434 228.194 133.674 223.332 134.776L223.682 138.07L218.35 174.164L227.461 179.867L261.354 132.238Z",
    fill: "#E3E1FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.354 132.238C261.354 132.238 257.635 133.175 254.555 132.238L233.94 146.566L234.971 121.624C232.117 129.434 228.194 133.674 223.332 134.776L223.682 138.07L218.35 174.164L227.461 179.867L261.354 132.238Z",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.555 132.238L233.94 146.566L226.201 156.953",
    fill: "#E3E1FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M254.555 132.238L233.94 146.566L226.201 156.953",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.146 117.922C245.617 128.747 254.59 136.676 265.946 130.095",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.643 127.86H195.534V92.3032H134.643V127.86Z",
    fill: "#653494"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.32 105.375L244.268 105.361C240.873 98.7312 238.959 91.2239 238.959 83.273C238.959 66.1793 247.809 51.1356 261.172 42.48L244.32 105.375Z",
    fill: "#653494"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.956 28.3573L165.089 1.59814L144.452 78.6157L244.32 105.375L264.956 28.3573Z",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.214 159.843L138.157 205.02C148.606 208.978 158.201 210.149 166.456 206.935C168.348 184.468 175.931 166.108 187.944 150.945C175.985 154.606 163.428 157.594 150.214 159.843Z",
    fill: "#E3E1FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.214 159.843L138.157 205.02C148.606 208.978 158.201 210.149 166.456 206.935C168.348 184.468 175.931 166.108 187.944 150.945C175.985 154.606 163.428 157.594 150.214 159.843Z",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.021 233.136C241.377 236.637 236.867 237.571 231.041 231.224C231.041 231.224 240.289 232.817 242.021 233.136ZM148.983 147.006C153.901 166.189 142.513 163.077 138.116 144.171C138.116 144.171 147.202 146.459 148.983 147.006Z",
    fill: "#653494"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.69 174.261L220.733 219.165L211.188 221.136L218.69 174.261Z",
    fill: "#653494"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.782 233.136C233.098 231.611 224.156 229.992 214.84 228.239C211.119 230.608 206.706 231.33 200.927 228.8C200.927 228.8 195.526 228.355 194.185 228.244C193.988 228.228 193.791 228.257 193.607 228.329C192.516 228.757 188.547 230.315 187.566 230.7C187.426 230.755 187.269 230.747 187.134 230.679C187.04 230.632 186.924 230.573 186.801 230.511C186.629 230.424 186.518 230.251 186.51 230.059C186.503 229.866 186.601 229.685 186.765 229.586C188.357 228.623 191.801 226.54 192.799 225.937C192.98 225.827 193.185 225.764 193.396 225.752C194.711 225.68 199.603 225.413 199.603 225.413C203.293 223.693 207.14 222.054 212.014 220.94L226.201 218.38",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M226.202 218.38C249.804 225.496 243.365 244.651 231.041 231.224",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.201 218.38L269.273 209.97",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M238.959 235.878C255.402 235.971 271.831 236.522 288.383 232.933C291.202 232.297 293.398 230.089 294.021 227.267C299.714 199.207 294.816 156.244 292.603 141.501C291.844 137.293 288.978 133.771 285.012 132.173C284.066 131.778 283.125 131.539 282.276 131.561",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.773 156.054L262.144 211.237",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M220.732 219.165L218.418 173.985L247.738 193.932",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 180.114L260.532 133.485C263.875 130.522 267.749 128.431 273.772 129.864",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.528 34.7043C314.335 34.7043 336.097 56.4676 336.097 83.2731C336.097 110.079 314.335 131.843 287.528 131.843C260.722 131.843 238.959 110.079 238.959 83.2731C238.959 56.4676 260.722 34.7043 287.528 34.7043Z",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7899 204.472C40.9317 204.472 46.7302 210.271 46.7302 217.413C46.7302 224.554 40.9317 230.353 33.7899 230.353C26.6481 230.353 20.8496 224.554 20.8496 217.413C20.8496 210.271 26.6481 204.472 33.7899 204.472Z",
    fill: "#E3E1FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11719 230.685H228.061",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M292.191 230.685H414.691",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189.789 227.215C189.789 227.215 191.532 225.206 192.487 224.105C192.868 223.666 193.442 223.443 194.02 223.511C196.082 223.751 200.884 224.312 200.884 224.312",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.347 114.469C297.646 131.617 287.47 169.594 304.618 199.294C321.765 228.995 359.743 239.171 389.443 222.023L327.347 114.469Z",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.853 87.2689L99.442 82.0676L61.1025 225.151L80.514 230.352L118.853 87.2689Z",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.741 105.044L106.657 62.8755H148.826L127.741 105.044Z",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M124.337 125.603C125.336 126.757 127.057 127.56 134.768 127.86C134.768 127.86 190.769 128.068 214.593 128.156C217.239 128.166 219.75 129.323 221.475 131.329C223.2 133.334 223.97 135.991 223.585 138.608C220.172 161.783 212.249 215.595 212.249 215.595",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.274 141.341C127.255 141.15 137.74 143.963 148.573 147.009",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.659 127.885C160.16 166.749 143.633 167.896 138.116 144.171",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.572 159.958C166.945 157.078 185.317 152.246 203.69 145.863",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.943 150.945C175.475 168.409 165.165 188.852 166.279 219.016C166.507 225.501 171.83 230.641 178.319 230.641C178.32 230.684 178.32 230.684 178.32 230.684",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M160.487 162.756C162.224 182.417 166.503 205.377 166.691 204.442",
    stroke: "#653494",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.253 165.367C311.749 165.367 316.211 169.829 316.211 175.325C316.211 180.82 311.749 185.282 306.253 185.282C300.758 185.282 296.296 180.82 296.296 175.325C296.296 169.829 300.758 165.367 306.253 165.367Z",
    fill: "#200849"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.613 129.451C307.424 134.248 310.466 141.301 310.466 149.158C310.466 160.211 304.445 169.673 295.941 173.506C295.058 159.841 293.573 147.961 292.603 141.501C291.844 137.293 288.978 133.771 285.012 132.173C284.476 131.949 283.941 131.775 283.424 131.671C284.775 131.785 286.145 131.842 287.528 131.842C292.793 131.842 297.863 131.003 302.613 129.451Z",
    fill: "#200849"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M218.965 129.29L222.052 105.508C222.052 105.508 217.553 104.666 216.043 104.383C215.725 104.324 215.433 104.167 215.209 103.935C214.186 102.874 211.165 99.7419 209.927 98.4591C209.608 98.1283 209.545 97.6275 209.772 97.2279C209.788 97.1989 209.805 97.1699 209.821 97.1403C210.098 96.6524 210.713 96.4735 211.208 96.7361C213.299 97.8445 218.35 100.521 218.35 100.521C222.26 98.7417 224.918 99.2875 228.113 102.195C229.656 101.698 231.24 101.672 232.869 102.19C234.623 102.756 235.781 104.428 235.694 106.27C235.465 111.225 234.971 121.624 234.971 121.624",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.698 117.679C241.263 119.562 246.821 119.597 252.365 116.643L244.245 105.571L234.15 102.875L235.698 107.044V117.679Z",
    fill: "#200849"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M115.829 99.705C115.829 99.705 116.279 99.5576 116.749 99.4031C117.389 99.1933 118.091 99.3793 118.543 99.8782C118.63 99.9734 118.716 100.069 118.798 100.159C119.104 100.497 119.262 100.944 119.235 101.4C118.804 109.022 119.473 115.416 120.952 120.907C124.029 120.577 125.354 122.47 125.704 125.603M243.258 122.12L246.632 131.178C249.209 130.824 250.94 129.151 251.08 128.001L243.258 122.12Z",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.337 125.603C114.299 127.015 115.115 136.101 120.766 141.236C119.008 145.596 112.465 145.671 104.044 144.065L115.829 99.7051",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.617 101.941L106.492 144.491",
    stroke: "#200849",
    strokeWidth: 1.28727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.07d5cddd97f96aa115cb63caad12e81b.svg";
export { ForwardRef as ReactComponent };